import { runStartOutcomeOf, scheduledWorkflowErrorOf } from "resources/scheduled-workflows/errors"
import { AI_NOT_ACTIVATED_COPY, BLOCKED_COPY, FEATURE_OFF_COPY } from "./blocked-copy"
import { blockedCopy, formatResetTime, nextBudgetReset, pausedUntilCopy, viewerTimeZone } from "./schedule-format"

export const RUN_STARTED_UNRECORDED_COPY = "The run started but couldn't be recorded. Don't start it again."
export const RUN_ARCHIVED_COPY = "This workflow is archived, so it can't run."
export const RUN_OUTCOME_UNKNOWN_COPY = "The run may have started. Check its last run before starting it again."

function budgetResetOf(resetsAt: string, now: Date): Date {
  const reset = new Date(resetsAt)
  return Number.isNaN(reset.getTime()) ? nextBudgetReset(now) : reset
}

export function activateErrorMessage(error: unknown, now: Date = new Date(), viewerZone: string = viewerTimeZone()): string {
  const workflowError = scheduledWorkflowErrorOf(error)
  switch (workflowError?.code) {
    case "SCHEDULED_WORKFLOW_CREDENTIAL_INVALID":
      return BLOCKED_COPY.credential_invalid
    case "SCHEDULED_WORKFLOW_PAT_AUTHORIZATION_ERROR":
      return BLOCKED_COPY.pat_disabled
    case "SCHEDULED_WORKFLOW_BUDGET_EXCEEDED":
      return `Today's limit is reached. Try again after ${formatResetTime(budgetResetOf(workflowError.details.resetsAt, now), now, viewerZone)}.`
    case "SCHEDULED_WORKFLOW_PLATFORM_PAUSED":
      return BLOCKED_COPY.platform_paused
    case "SCHEDULED_WORKFLOW_PROXY_MANAGED_AGENT_DISABLED":
      return FEATURE_OFF_COPY
    case "SCHEDULED_WORKFLOW_PROXY_AI_NOT_ACTIVATED":
      return AI_NOT_ACTIVATED_COPY
    case "SCHEDULED_WORKFLOW_ACTIVATE_ARCHIVED":
      return "This workflow is archived, so it can't be turned on."
    default:
      return "Couldn't turn this workflow on. Please try again."
  }
}

export function pauseErrorMessage(error: unknown): string {
  const workflowError = scheduledWorkflowErrorOf(error)
  switch (workflowError?.code) {
    case "SCHEDULED_WORKFLOW_PAUSE_ARCHIVED":
      return "This workflow is archived, so it can't be paused."
    default:
      return "Couldn't pause this workflow. Please try again."
  }
}

export function startRunErrorMessage(error: unknown, now: Date = new Date(), viewerZone: string = viewerTimeZone()): string {
  const outcome = runStartOutcomeOf(error)
  if (outcome === "started") return RUN_STARTED_UNRECORDED_COPY
  if (outcome === "unknown") return RUN_OUTCOME_UNKNOWN_COPY
  const workflowError = scheduledWorkflowErrorOf(error)
  switch (workflowError?.code) {
    case "SCHEDULED_WORKFLOW_BUDGET_EXCEEDED":
      return pausedUntilCopy(budgetResetOf(workflowError.details.resetsAt, now), now, viewerZone)
    case "SCHEDULED_WORKFLOW_RUN_BLOCKED":
      return blockedCopy(workflowError.details.blockedReason, now, now, viewerZone)
    case "SCHEDULED_WORKFLOW_RUN_ARCHIVED":
      return RUN_ARCHIVED_COPY
    case "SCHEDULED_WORKFLOW_PAT_AUTHORIZATION_ERROR":
      return BLOCKED_COPY.pat_disabled
    case "SCHEDULED_WORKFLOW_PROXY_MANAGED_AGENT_DISABLED":
      return FEATURE_OFF_COPY
    case "SCHEDULED_WORKFLOW_PROXY_AI_NOT_ACTIVATED":
      return AI_NOT_ACTIVATED_COPY
    default:
      return "Couldn't start the run. Please try again."
  }
}
